var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pulse-tag",class:[_vm.color ? '' : `pulse-tag--${_vm.severity}`, { 'pulse-tag--rounded': _vm.rounded }],style:(_vm.customStyle)},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }